import React from 'react';
import { Layout } from '@myua/kit';
import { Close } from '@myua/icons/dist/linear16';
import { useDispatch, useSelector } from 'react-redux';
import { AssetDetails } from '../../finder/components/AssetDetails';
import { getDetailsVisible, getSelected } from '../../finder/selectors';
import * as finderActions from '../../finder/actions';
import { ThemeContext } from '../../../../general/components/FullscreenPreview/model';

export const LayoutSiderRight = () => {
  const dispatch = useDispatch();
  const visible = useSelector(getDetailsVisible);
  const selected = useSelector(getSelected);

  if (selected.ids.length === 0) {
    return null;
  }

  return (
    <Layout.Sider
      theme="light"
      className="al-app-layout-right"
      collapsedWidth={0}
      collapsed={!visible}
    >
      {visible ? (
        <button
          type="button"
          className="al-finder-details-close"
          title="Close sidebar"
          // Крестик работает так же, как кнопка-тогл в шапке: просто сворачивает
          // сайдбар, который дальше не раскрывается автоматически (MYUA-16254).
          onClick={() => dispatch(finderActions.setDetailsVisible({ visible: false }))}
        >
          <Close />
        </button>
      ) : null}
      <ThemeContext.Provider value={{ invert: true }}>
        <AssetDetails />
      </ThemeContext.Provider>
    </Layout.Sider>
  );
};
